var BinarySearch = /** @class */ (function () {
    function BinarySearch(comparer) {
        this.comparer = comparer;
    }
    BinarySearch.prototype.has = function (sortedData, x) {
        return this.getOrder(sortedData, x) !== -1;
    };
    BinarySearch.prototype.getOrder = function (sortedData, x) {
        var lower = 0;
        var upper = sortedData.length;
        while (lower < upper) {
            var mid = lower + Math.floor((upper - lower) / 2);
            var item = sortedData[mid];
            var cmp = this.comparer.cmp(x, item);
            if (cmp === 0) {
                return mid;
            }
            if (cmp > 0) {
                lower = mid + 1;
            }
            else {
                upper = mid;
            }
        }
        return -1;
    };
    return BinarySearch;
}());
export default BinarySearch;
//# sourceMappingURL=binary-search.js.map